// extracted by mini-css-extract-plugin
export default {"sorter":"sorter--X6_Js","icon":"icon--b16dv","content":"content--wSS7w"};